import InfoCard from "../InfoCard/InfoCard";
import { CalculationVehicleCardProps } from "./types";

const CalculationVehicleCard: React.FC<CalculationVehicleCardProps> = (
  props
) => {
  const { calculation } = props;

  const vehicleName =
    [
      calculation.manufacturer?.name,
      calculation.model?.name,
      calculation.type?.name,
    ]
      .filter(Boolean)
      .join(" ") || "-";

  const heroImage = calculation.picture || "/media/images/logo.png";

  const yearRange =
    calculation.model?.yearFrom && calculation.model?.yearTo
      ? `${calculation.model.yearFrom} – ${calculation.model.yearTo}`
      : calculation.model?.yearFrom
        ? `${calculation.model.yearFrom} –`
        : calculation.model?.year
          ? `${calculation.model.year}`
          : "";

  return (
    <div>
      {/* Slika vozila */}
      <div className="pt-2 px-4 mb-3">
        <div className="relative overflow-hidden bg-gray-100 rounded-lg h-[220px]">
          <img
            src={heroImage}
            alt={vehicleName}
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Naziv vozila */}
      <div className="border-b border-slate-200 px-4 pb-3">
        <div className="text-md font-bold text-slate-600 truncate">
          {vehicleName}
        </div>
        <div className="text-sm text-slate-500">Kalkulacija najma</div>
      </div>

      {/* Tip vozila */}
      <div className="border-b border-slate-200 pt-4 px-4">
        <div className="text-sm font-bold text-slate-600 mb-3">Tip vozila</div>
        <div className="grid grid-cols-4 gap-3 mb-4">
          <InfoCard label="Marka vozila" value={calculation.manufacturer?.name} />
          <InfoCard label="Model vozila" value={calculation.model?.name} />
          <InfoCard label="Tip vozila" value={calculation.type?.name} />
          <InfoCard label="Godina" value={yearRange} />
        </div>
      </div>

      {/* Osnovne informacije */}
      <div className="pt-4 px-4 pb-4">
        <div className="text-sm font-bold text-slate-600 mb-3">
          Osnovne informacije
        </div>
        <div className="grid grid-cols-4 gap-3">
          <InfoCard label="Gorivo" value={calculation.type?.fuelType?.name} />
          <div className="flex">
            <div className="border border-slate-200 bg-slate-50 p-3 min-h-[70px] rounded-tl-sm rounded-bl-sm flex-1">
              <div className="text-sm text-slate-600">kW</div>
              <div className="text-md font-medium text-slate-800 truncate">
                {calculation.type?.maximumPowerKw
                  ? `${calculation.type.maximumPowerKw} kW`
                  : "-"}
              </div>
            </div>
            <div className="border border-slate-200 bg-slate-50 p-3 min-h-[70px] mx-[-1px] flex-1">
              <div className="text-sm text-slate-600">Hp</div>
              <div className="text-md font-medium text-slate-800 truncate">
                {calculation.type?.maximumPowerHp
                  ? `${calculation.type.maximumPowerHp} ks`
                  : "-"}
              </div>
            </div>
          </div>
          <InfoCard
            label="Zapremina"
            value={
              calculation.type?.cylinderCapacity
                ? `${calculation.type.cylinderCapacity} cm³`
                : ""
            }
          />
          <InfoCard
            label="Mjenjač"
            value={calculation.type?.transmission?.name}
          />
        </div>
      </div>
    </div>
  );
};

export default CalculationVehicleCard;
